import { ContextBase, State, StateTransitionData } from '@ortho-next/nextray-core';
import { Actions, Context, StateTypes } from './Context';
import { StateDescription, WorkflowRunning } from './State';

/**
 * State indicating that the application is loading and restoring data. At the end it will the state loaded.
 */
export class Loading extends State<Actions> {
	protected declare _context: Context;

	public stateDescription: StateDescription = {
		isWorkflowRunning: WorkflowRunning.none,
		isPointsPositioningRunning: false,
	};

	constructor(context: ContextBase) {
		super(context, undefined!, StateTypes.loading);
	}

	public initState(): void {
		// empty
	}

	protected handleChangeStateEvent<K extends keyof Actions>(event: K, args: Actions[K]): StateTransitionData {
		switch (event) {
			case "setCalibrationRegisteringMode":
				this.stateDescription.isPointsPositioningRunning = args as boolean;
				return this.dispatchToMain(event, args);
			case "startRotate":
				this.stateDescription.isWorkflowRunning = WorkflowRunning.rotate;
				return this.dispatchToMain(event, args);
			case "confirmRotate":
				this._context.updateDataToSave();
				this.stateDescription.isWorkflowRunning = WorkflowRunning.none;
				return this.dispatchToMain(event, args);
			case "setCalibrationMode":
			case "setCalibrationCircleFromPoints":
			case "calibrate":
			case "startCalibration":
			case "resetCalibration":
			case "setFlip":
			case "setRing":
			case "setRingCalibrationData":
			case "resetImageTools":
				return this.dispatchToMain(event, args);
		}

		return super.handleNotChangeStateEvent(event, args);
	}

}
